const MAPS_LIMIT = 30

export { MAPS_LIMIT }
